import actionTypes from 'constants/actionTypes'


export default [
  actionTypes.BOOKMARKS.ONE.DELETE,
  actionTypes.NODES.ONE.DELETE,
  actionTypes.EDGES.ONE.DELETE,
  actionTypes.KINDS.ONE.DELETE,
  actionTypes.NODES.MULTI.DELETE,
  actionTypes.EDGES.MULTI.DELETE
]
